@let m = meeting();

<div class="title-editor">
  @if (!editing()) {
    <div class="title-editor__line">
      <h2 class="title-editor__title">{{ title() }}</h2>
      @if (showPencil()) {
        <button
          type="button"
          class="title-editor__pencil"
          title="Renomear"
          aria-label="Renomear a call"
          (click)="startEditing()">
          <i class="pi pi-pencil" aria-hidden="true"></i>
        </button>
      }
    </div>
  } @else {
    <div class="title-editor__form">
      <app-input
        class="title-editor__input"
        [ngModel]="draft()"
        (ngModelChange)="draft.set($event ?? '')"
        [placeholder]="'Deixe vazio para usar o título automático'"
        [maxLength]="maxLength"
        [textCenter]="false" />
      <div class="title-editor__actions">
        <app-button
          [label]="'Salvar'"
          [type]="'button'"
          [isLoading]="saving()"
          [disabled]="!canSave()"
          (sendButtonClick)="save()" />
        <app-button
          [label]="'Cancelar'"
          [type]="'button'"
          [theme]="'white'"
          [disabled]="saving()"
          (sendButtonClick)="cancel()" />
        @if (suggestedTitle(); as suggested) {
          <button
            type="button"
            class="title-editor__suggested"
            [title]="suggested"
            [disabled]="saving()"
            (click)="useSuggested()">
            <i class="pi pi-sparkles" aria-hidden="true"></i> Usar o sugerido pelo Cog
          </button>
        }
      </div>
    </div>
  }

  @if (m.shortDescription) {
    <p class="title-editor__description">{{ m.shortDescription }}</p>
  }

  @if (originalTitle() || renamedBy()) {
    <p class="title-editor__origin">
      @if (originalTitle(); as original) {
        <span>Título original: “{{ original }}”</span>
      }
      @if (renamedBy(); as renamed) {
        <span>{{ renamed }}</span>
      }
    </p>
  }
</div>
